import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import EZAlert from "../popups/EZAlert";
import Popups from "../popups/Popups";
import CancelQuestionnaire from "../popups/CancelQuestionnaire";
import { ReserveState } from "../reserve-state/ReserveStateTypes";
import Tools from "@root/ts/Tools";
import CollapseWrapper from "../ui/CollapseWrapper";
import PayFailDetail from "../reserve-state/PayFailDetail";
import PayByAtm from "../reserve-state/PayByAtm";
import DisocuntList from "../common/DiscountList";
const discountItemTemplate = require("./../../../partials/fill-passenger/discount-item.hbs");

export default class OrderDetail extends ComponentBase {
  _state: ReserveState.OrderState;
  _collapseWrapper: CollapseWrapper;
  _orderSN: string;

  constructor(elem: ComponentElem, orderData: ReserveState.OrderData, stateData?: ReserveState.StateData) {
    super(elem);

    this.$root.find(".btn-cancel")
      .on("click", (event: JQuery.ClickEvent) => {
        event.preventDefault();
        EZAlert.instance.complexConfirm("取消訂單", "是否確定要取消這筆訂單？", "取消完成後，此訂單所使用的折扣券與點數將不退還。", "取消操作", "確認取消", { autoClose: false })
          .then((isConfirm) => {
            if (isConfirm) {
              CancelQuestionnaire.instance.open(this._orderSN)
                .then(() => {
                  this.updateState("cancel_pending" as ReserveState.OrderState);
                });
            } else {
              Popups.close();
            }
          });
      });
    this._collapseWrapper = this.seekComponentById("main-collapse") as CollapseWrapper;

    if (stateData) {
      if (!(stateData.state in ReserveState.OrderState))
        throw new Error(`illegal state ${stateData.state}`);
      this.updateState(stateData.state, stateData.fail_reaspons, stateData.atm_data, stateData.cancel_detail);
    }
    this.updateDetail(orderData);
  }

  updateState(stateValue: ReserveState.OrderState, faiilReaspons?: string[], atmData?: ReserveState.ATMData, cancelDetail?: ReserveState.CancelDetail) {
    this._state = stateValue;
    let setting = ReserveState.Setting[this._state];

    if (setting.cancelLabel) this.$root.find(".cancel-label>.text").text(setting.cancelLabel);
    if (setting.collapseContent) this._collapseWrapper.toggle(true);

    if (faiilReaspons && stateValue === "pay_fail") {
      let payFailDetail: PayFailDetail = Tools.seekComponentByName(`pay-fail-detail`);
      payFailDetail.update(faiilReaspons);
      payFailDetail.toggle(true);
    }

    if (cancelDetail && (stateValue === ReserveState.OrderState.cancel_success || stateValue === ReserveState.OrderState.refund_success)) {
      this.$root.find(".raw-amount>.price").text(cancelDetail.refund_raw);
      if (cancelDetail.refund_sports_voucher_point) {
        this.$root.find(".service-fee>.price").text(cancelDetail.refund_sports_voucher_point);
      } else {
        this.$root.find(".service-fee").css("display", "none");
      }
      this.$root.find(".after-amount>.value").text(cancelDetail.refund_amount);
    }

    (<PayByAtm>Tools.seekComponentByName("pay-by-atm")).update((stateValue === "pay_pending" && atmData) ? atmData : null);
    if (stateValue === "refund_success" || stateValue === "cancel_success")
      this.$root.find(".refund").css("display", "block");
    this.$root.attr("main-state", setting.mainState);
  }


  // 訂單更新
  updateDetail(orderData: ReserveState.OrderData) {
    let data = orderData.reserve_record;
    this._orderSN = orderData.order_sn;

    Tools.updateValue(this.$root, "order_sn", orderData.order_sn);
    Tools.updateValue(this.$root, "full_name", Tools.getFullName(data.first_name, data.surname));
    Tools.updateValue(this.$root, "first_name", data.first_name);
    Tools.updateValue(this.$root, "surname", data.surname);
    Tools.updateValue(this.$root, "country", data.country);
    Tools.updateValue(this.$root, "phone", data.phone);
    Tools.updateValue(this.$root, "email", data.email);
    Tools.updateValue(this.$root, "product_name", orderData.cart_record.name);
    Tools.updateValue(this.$root, "plan_name", orderData.cart_record.plan_data.name);
    Tools.updateValue(this.$root, "date", Tools.formatDateString(orderData.cart_record.plan_data.date));
    Tools.updateValue(this.$root, "time", orderData.cart_record.plan_data.time);
    // Tools.updateValue(this.$root, "tax_rate", orderData.tax_rate);
    // Tools.updateValue(this.$root, "service_rate", orderData.service_rate);

    let sum = 0;
    let $unitList = this.$root.find(".unit-list").empty();

    orderData.cart_record.plan_data.unit_data.forEach((obj: any) => {
      let count = Tools.parseInt(obj.count);
      let price = Tools.formatNumber(parseInt(obj.price) * count);

      if (count > 0)
        $unitList.append(`<div component="unit-li">
          <div class="name">${obj.name} x${obj.count}</div>
          <div class="price" prefix="$">${price}</div>
        </div>`);

      let unitSum = Tools.parseInt(obj.price) * Tools.parseInt(obj.count);
      sum += unitSum;
    });

    // { id: item.type, name: item.name, value: item.value }
    let discountList = new DisocuntList();
    discountList.setList(orderData.discounts);
    if (discountList.getCount() > 0)
      discountList.update(this.$root.find(".discount"), discountItemTemplate);
    else
      this.$root.find(".discount").parent().hide();
    this.$root.find(`[data-value="subtotal"] .price`).text(orderData.subtotal);
    Tools.updateValue(this.$root, "after_tax", orderData.after_tax_price);
    Tools.updateValue(this.$root, "tax_and_service", orderData.tax_and_service);
    if (orderData?.sportz_voucher !== 0) {
      Tools.updateValue(this.$root, "sportz_voucher", orderData.sportz_voucher);
    } else {
      this.$root.find(".total .r3").hide();
    }
    Tools.updateValue(this.$root, "final", orderData.total_price);
    // 點數回饋
    if (orderData.points_reward)
      Tools.updateValue(this.$root, "ep_gain", orderData.points_reward);
    else
      this.$root.find(".ep-gain").css("display", "none");
  }
}